var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SvgComponent",
    {
      attrs: { width: "90", height: "90", viewBox: "0 0 90 90", fill: "none" },
    },
    [
      _c("rect", {
        attrs: {
          x: "7",
          y: "7",
          width: "76",
          height: "76",
          rx: "38",
          fill: "#87F2B9",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "7",
          y: "7",
          width: "76",
          height: "76",
          rx: "38",
          stroke: "#E3FCEF",
          "stroke-width": "13.5714",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M59.1421 59.1421C55.3914 62.8929 50.3043 65 45 65C39.6957 65 34.6086 62.8929 30.8579 59.1421C27.1071 55.3914 25 50.3043 25 45C25 39.6957 27.1071 34.6086 30.8579 30.8579C34.6086 27.1071 39.6957 25 45 25C50.3043 25 55.3914 27.1071 59.1421 30.8579C62.8929 34.6086 65 39.6957 65 45C65 50.3043 62.8929 55.3914 59.1421 59.1421ZM53.8281 38.6797C54.5625 39.4062 54.5625 40.5938 53.8281 41.3281L43.8359 51.3281C43.1094 52.0625 41.9219 52.0625 41.1875 51.3281L36.1875 46.3281C35.4531 45.6016 35.4609 44.4141 36.1875 43.6797C36.9141 42.9453 38.1016 42.9453 38.8359 43.6797L42.5078 47.3516L51.1797 38.6797C51.9062 37.9453 53.0938 37.9531 53.8281 38.6797Z",
          fill: "#0E8345",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M53.8281 41.3281C54.5625 40.5938 54.5625 39.4062 53.8281 38.6797C53.0938 37.9531 51.9062 37.9453 51.1797 38.6797L42.5078 47.3516L38.8359 43.6797C38.1016 42.9453 36.9141 42.9453 36.1875 43.6797C35.4609 44.4141 35.4531 45.6016 36.1875 46.3281L41.1875 51.3281C41.9219 52.0625 43.1094 52.0625 43.8359 51.3281L53.8281 41.3281Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }